// Sin imports a propósito (Blockly arrastra jsdom): los tests corren con testEnvironment 'node'.
// El valor del campo es { leds: { 0..63: boolean } }, la forma que guarda prod, para que los
// proyectos viejos abran igual.
export const ROWS = 8;
export const COLS = 8;
export const TOTAL = ROWS * COLS;

// Los LEDs se guardan rotados 90 grados en sentido horario respecto de la grilla y el generador
// lee ese orden. No es un bug: cambiarlo rompe todos los proyectos existentes.
export const toStoredIndex = (index) => COLS * ((index % COLS) + 1) - Math.floor(index / COLS) - 1;

export const emptyLeds = () => {
  const leds = {};
  for (let i = 0; i < TOTAL; i += 1) leds[i] = false;
  return leds;
};

// En índices de grilla (sin rotar); presetToLeds los convierte al orden guardado.
export const PRESETS = {
  dice: {
    1: [27, 28, 35, 36],
    2: [6, 7, 14, 15, 48, 49, 56, 57],
    3: [6, 7, 14, 15, 27, 28, 35, 36, 48, 49, 56, 57],
    4: [0, 1, 6, 7, 8, 9, 14, 15, 48, 49, 54, 55, 56, 57, 62, 63],
    5: [0, 1, 6, 7, 8, 9, 14, 15, 27, 28, 35, 36, 48, 49, 54, 55, 56, 57, 62, 63],
    6: [0, 1, 6, 7, 8, 9, 14, 15, 24, 25, 30, 31, 32, 33, 38, 39, 48, 49, 54, 55, 56, 57, 62, 63],
  },
  emotions: {
    1: [18, 21, 41, 46, 50, 51, 52, 53],
    2: [18, 21, 41, 42, 43, 44, 45, 46, 49, 50, 51, 52, 53, 54],
    3: [18, 21, 42, 43, 44, 45, 49, 54],
    4: [18, 21, 33, 38, 42, 43, 44, 45, 51, 52, 59, 60],
    5: [9, 14, 18, 21, 42, 43, 44, 45, 50, 51, 52, 53],
    6: [9, 10, 13, 14, 17, 18, 21, 22, 35, 36, 42, 45, 50, 53, 59, 60],
    7: [17, 18, 21, 22, 42, 43, 44, 45, 50, 51, 52, 53],
    8: [9, 10, 13, 14, 16, 17, 18, 19, 20, 21, 22, 23, 25, 26, 29, 30, 41, 46, 50, 51, 52, 53],
    9: [9, 14, 16, 18, 21, 23, 41, 46, 50, 51, 52, 53],
    10: [10, 18, 21, 22, 41, 46, 50, 51, 52, 53],
  },
  icons: {
    1: [0, 7, 9, 14, 18, 21, 27, 28, 35, 36, 42, 45, 49, 54, 56, 63],
    2: [15, 22, 23, 29, 30, 36, 37, 40, 41, 43, 44, 49, 50, 51, 58],
    3: [18, 21, 25, 26, 27, 28, 29, 30, 33, 34, 35, 36, 37, 38, 42, 43, 44, 45, 51, 52],
    4: [9, 10, 13, 14, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 50, 51, 52, 53, 59, 60],
    5: [3, 4, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 30, 31, 33, 34, 35, 36, 37, 38, 41, 42, 45, 46, 49, 50, 53, 54, 57, 58, 61, 62],
    6: [2, 3, 4, 5, 9, 10, 11, 12, 13, 14, 16, 17, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52, 55, 56, 59, 60, 63],
    7: [4, 5, 12, 13, 14, 20, 21, 28, 29, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 54, 58, 59, 60, 61],
    8: [3, 4, 11, 12, 18, 19, 20, 21, 25, 26, 27, 28, 29, 30, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 59, 60],
    9: [0, 1, 2, 8, 9, 10, 18, 26, 30, 34, 35, 36, 37, 42, 45, 50, 53, 58, 61],
    10: [0, 1, 2, 8, 9, 10, 15, 18, 19, 22, 27, 28, 29, 35, 36, 42, 43, 45, 48, 49, 50, 54, 56, 57, 58, 63],
    11: [2, 3, 4, 5, 9, 10, 11, 12, 13, 14, 16, 17, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 34, 35, 36, 37, 42, 43, 44, 45, 50, 51, 52, 53, 58, 59, 60, 61],
    12: [0, 8, 9, 16, 18, 24, 27, 32, 36, 40, 45, 48, 54, 56, 57, 58, 59, 60, 61, 62, 63],
  },
};

export const presetToLeds = (gridIndexes) => {
  const leds = emptyLeds();
  gridIndexes.forEach((i) => { leds[toStoredIndex(i)] = true; });
  return leds;
};
